import { QueryClient } from '@tanstack/react-query'
import { ConsignmentItem, ConsignmentItemDetails } from '../models/types'
import { QueryKeys } from '../../../key-registry'
import { fromConsignmentItemDetails } from '../models/mapper'

function getConsignmentItemSuccessHandlers(
  queryClient: QueryClient,
  consignmentId: number,
  houseConsignmentId: number,
) {
  return {
    onCreateSuccess: async (savedConsignmentItem: ConsignmentItemDetails) => {
      if (!savedConsignmentItem?.id) throw new Error('Missing consignment item ID')

      queryClient.setQueryData<ConsignmentItem[]>(QueryKeys.consignmentItem.all({ consignmentId, houseConsignmentId }), (prev) => (prev
        ? [...prev, fromConsignmentItemDetails(savedConsignmentItem)] : prev))

      await queryClient.invalidateQueries({
        queryKey: QueryKeys.houseConsignment.all(consignmentId),
      })
      await queryClient.invalidateQueries(QueryKeys.consignment.summary(consignmentId))
    },
    onUpdateSuccess: async (savedConsignmentItem: ConsignmentItemDetails) => {
      if (!savedConsignmentItem?.id) throw new Error('Missing consignment item ID')

      queryClient.setQueryData<ConsignmentItemDetails>(
        QueryKeys.consignmentItem.details(savedConsignmentItem.id),
        savedConsignmentItem,
      )
      await queryClient.invalidateQueries({
        queryKey: QueryKeys.consignmentItem.all({ consignmentId, houseConsignmentId }),
      })
      await queryClient.invalidateQueries({
        queryKey: QueryKeys.houseConsignment.all(consignmentId),
      })
      await queryClient.invalidateQueries(QueryKeys.consignment.summary(consignmentId))
    },
    onDeleteSuccess: async (_: void, deleteConsignmentItemId: number) => {
      queryClient.setQueryData<ConsignmentItem[]>(QueryKeys.consignmentItem.all({ consignmentId, houseConsignmentId }), (prev) => (prev
        ? prev.filter((item) => item.id !== deleteConsignmentItemId) : prev))

      await queryClient.invalidateQueries({
        queryKey: QueryKeys.houseConsignment.all(consignmentId),
      })
      await queryClient.invalidateQueries(QueryKeys.consignment.summary(consignmentId))
    },
  }
}

export default getConsignmentItemSuccessHandlers
